import Typewriter from "typewriter-effect";

const Typewritter = () => {
  return (
    <div style={{ color: "#FF5733", fontWeight: "bolder" }}>
      <Typewriter
        options={{
          strings: ["FULL STACK DEVELOPER (MERN)", "NODEJS DEVELOPER", "UI UX DESIGNER"],
          autoStart: true,
          loop: true,
        }}
      />
    </div>
  );
};

export default Typewritter;
